'use client';

import { useState, useEffect } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/app/homepage/components/Footer';


import BlogHero from './BlogHero';
import FeaturedArticles from './FeaturedArticles';
import NewsletterSection from './NewsletterSection';
import { blogPosts, Article } from '@/lib/blog-posts';

const BlogContent = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const articles: Article[] = Object.values(blogPosts);

  const featuredArticles = articles.filter((article) => article.featured);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <Header />
        <div className="pt-20">
          <div className="w-full h-96 bg-muted animate-pulse" />
        </div>
      </div>);

  }

  return (
    <div className="min-h-screen">
      <Header />

      <main>
        <BlogHero />

        <FeaturedArticles articles={featuredArticles} />


        <NewsletterSection />
      </main>
      <Footer />
    </div>);

};

export default BlogContent;